import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

// const rtlBootstrap = '//cdn.rawgit.com/morteza/bootstrap-rtl/v3.3.4/dist/css/bootstrap-rtl.min.css';
// const rtlTheme = 'assets/theme/theme.rtl.css';
@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss']
})
export class PublicComponent implements OnInit {

  cssUrl: string = '';
  // safeUrl: any = this.sanitizer.bypassSecurityTrustResourceUrl(localStorage.getItem('lang') == 'en' ? '' : (localStorage.getItem('lang') == 'ar' ? rtlBootstrap : ''));
  // safeUrl2: any = this.sanitizer.bypassSecurityTrustResourceUrl(localStorage.getItem('lang') == 'en' ? '' : (localStorage.getItem('lang') == 'ar' ? rtlTheme : ''));
  

  constructor(public sanitizer: DomSanitizer) {
    if (localStorage.getItem('lang') == undefined || localStorage.getItem('lang') == null)
      localStorage.setItem('lang', 'en')
  }
  onLangChange(event) {
    var langObject = event;
    // if (langObject.langObject == "ar") {
    //   this.cssUrl = '//cdn.rawgit.com/morteza/bootstrap-rtl/v3.3.4/dist/css/bootstrap-rtl.min.css';
    //   this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.cssUrl)
    //   this.safeUrl2 = this.sanitizer.bypassSecurityTrustResourceUrl('assets/theme/theme.rtl.scss');
    //   localStorage.setItem('lang', langObject.langObject)
    // }
    // else if (langObject.langObject == "en") {
    //   this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('')
    //   this.safeUrl2 = this.sanitizer.bypassSecurityTrustResourceUrl('');
    //   localStorage.setItem('lang', langObject.langObject)
    // }
    localStorage.setItem('lang', langObject.langObject)
  }
  ngOnInit(): void {
   
  }


}
